import type { SelectFilterOption, SelectFilterMonad } from 'packages/search/search-page/src/common/constants/filters/select-filter/types';

import type { CloudConfig } from '../../../../../common/constants/filters/cloud-config/types';
import { ProductKeys, type ProductKeys3P } from '../../../../../common/constants/products';
import { getProducts3PFromConfigForFilter } from '../../../../../common/utils/filters';
import { createSingleSelectFilter } from '../../../../filters/single-select-filter';

import { getAllOpportunityStatusOptions } from './utils';

const salesforceProducts: ProductKeys[] = [ProductKeys.Salesforce];
const products3PFromConfig: ProductKeys3P[] = getProducts3PFromConfigForFilter('opportunityStatus');

const loadQueryParams = (queryParams: string[], config: CloudConfig) => {
	const allOptions = getAllOpportunityStatusOptions(config);
	return allOptions
		.filter((option) => !option.isDefault)
		.filter((option) => queryParams.includes(option.queryParamValue))
		.map((option) => ({
			...option,
			product: config.product,
		}));
};

const getInitialOptions = (config: CloudConfig) => {
	const allOptions = getAllOpportunityStatusOptions(config);
	return allOptions.map((option) => ({
		...option,
		product: config.product,
	}));
};

export const filter: Readonly<{
    id: "opportunityStatus";
    type: "single-select" | "multi-select";
    queryParams: {
        key: string;
        getState: (queryParams: Record<string, string[]>, cloudId: string) => Readonly<{
            id: "opportunityStatus";
            type: "single-select" | "multi-select";
            options: SelectFilterOption[];
            didMount: boolean;
            didMountPerProducts: Record<string, boolean>;
            hasSelection: boolean;
            alwaysVisible: boolean;
            universal: boolean;
            value: string[];
            selectedOptions: SelectFilterOption[];
            queryParams: {
                options: SelectFilterOption[];
                isLoading: boolean;
            };
            initialOptions: {
                options: SelectFilterOption[];
                isLoading: boolean;
            };
            lookup: {
                options: SelectFilterOption[];
                lookupResultOptions: SelectFilterOption[];
                input: string;
                isLoading: boolean;
                isActive: boolean;
                isDefined: boolean;
            };
            products: ProductKeys[];
            customValue?: Record<string, string>;
            customValueFields?: string[];
            isAutoApplied: boolean;
            wasAutoApplied: boolean;
        }>;
    };
    products: ProductKeys[];
    universal: boolean;
    customValueFields?: string[];
    withState: (state: unknown, config: CloudConfig) => SelectFilterMonad<"opportunityStatus">;
    getInitialState: (config: CloudConfig) => SelectFilterMonad<"opportunityStatus">;
    isCompatible: (filterId?: string) => boolean;
    isSupportCustomValue: boolean;
    isSuggestedFilter?: (primaryProduct?: string) => boolean;
}> = createSingleSelectFilter({
	id: 'opportunityStatus' as const,
	products: [...salesforceProducts, ...products3PFromConfig],
	alwaysVisible: false,
	universal: false,
	queryParams: {
		key: 'opportunityStatus',
		fetcher: async (queryParams, config) => {
			return loadQueryParams(queryParams, config);
		},
	},
	initialOptions: {
		fetcher: async (config) => {
			return getInitialOptions(config);
		},
	},
});
